import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { BeatLoader } from 'react-spinners';
import { renderToString } from 'react-dom/server';

import { appContentUrl, imgixUrl } from 'settings';
import { APIHandler, AddFavorite, SharingPopup } from 'C4';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class TrainingImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      href: null,
      scrolled: false,
    };
  }

  componentDidMount() {
    const { scrolled } = this.state;
    this.mounted = true;
    document.addEventListener('scroll', () => {
      if (!scrolled && this.mounted) {
        this.setState({ scrolled: true });
      }
    });
  }

  componentWillUnmount() {
    const { scrolled } = this.state;
    this.mounted = false;
    document.removeEventListener('scroll', () => {
      if (!scrolled && this.mounted) {
        this.setState({ scrolled: true });
      }
    });
  }

  render() {
    const { loading, href, scrolled } = this.state;
    const {
      appId,
      contentComplete,
      error,
      image,
      imageCredits,
      pageID,
      type,
      upID,
    } = this.props;

    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['close'],
      share: {
        tpl: renderToString(<SharingPopup url={`${appContentUrl}${appId}/${image}`} />),
      },
    };

    return (
      <div className={`trainingContent__image ${type !== undefined ? type.toLowerCase() : ''}`}>
        <div className="trainingContent__image--wrapper">
          <span className="loadingSpinner" style={{ opacity: loading ? 0 : 1 }}>{imageCredits}</span>
          {loading &&
            <BeatLoader
              color="#aaa"
              loading={loading}
            />}
          <img
            className={`${type !== undefined ? type.toLowerCase() : null} ${type === 'Photo' && 'photoType'}`}
            data-fancybox={`trainingImage_${image}`}
            data-options={JSON.stringify(fancyOptions)}
            data-caption={imageCredits}
            href={href}
            src={`${imgixUrl}${appId}/${image}?quality=70&fm=jpg`}
            style={{ opacity: loading ? 0 : 1 }}
            alt={image.toString()}
            onLoad={() => {
              this.setState({
                loading: false,
                href: APIHandler.getDownloadURL(`${appContentUrl}${appId}/${image}`),
              }, () => {
                if (!scrolled) {
                  window.scrollTo(0, 0);
                }
              });
              contentComplete();
            }}
          />
          {imageCredits && <h3>{imageCredits}</h3>}
          <span className="zoomIcon"><FontAwesomeIcon icon={['far', 'search-plus']} /></span>
          {type === 'Photo' &&
            <AddFavorite
              appId={appId}
              viewType="p"
              upID={upID}
              pageID={pageID}
            />}
        </div>
      </div>
    );
  }
}

TrainingImage.propTypes = {
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  imageCredits: PropTypes.string,
  pageID: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string,
};

TrainingImage.defaultProps = {
  imageCredits: '',
  type: '',
  upID: '',
  pageID: '',
};
